// App.js
import { Routes, Route , Router} from 'react-router-dom';
import Buyer from './Buyer';
import Seller from './Seller';
import GoogleAnalytics from "./GoogleAnalytics";

const App = () => {
   return (
      <>
      <GoogleAnalytics />
         <Routes>
            <Route path="/" element={<Buyer/>} />
            <Route path="/Seller" element={<Seller/>} />
         </Routes>
      </>
   );
};
 
export default App;